/**
 * @Author: v_jppjpeng
 * @Date: 2023-08-03 12:32:07
 * @Explain: 标签管理
 */
import type { HttpResponse } from '../data.d';
import http from '../http';

const MODEL = '/tag';

export default {
  // 列表
  // getList(data: Record<any, any>) {
  //   return http.post(
  //     `${MODEL}/list`,
  //     { isBuiltin: true, ...data },
  //   );
  // },
  // 列表
  getList(data: Record<any, any>) {
    return http.post(
      `${MODEL}/list_new`,
      { isBuiltin: true, ...data, tag: data.tag?.trim() },
      { params: { switchReqToUnderline: true } },
    );
  },
  // 删除
  onDel(data: Record<any, any>) {
    return http.post(`${MODEL}/del`, data);
  },
  // 添加、编辑
  onAddEdit(data: Record<any, any>) {
    return http.post(`${MODEL}/save`, data);
  },
  // 是否存在
  checkName(data: Record<any, any>) {
    return http.post(`${MODEL}/check`, data);
  },
  // 获取所有标签
  getAllTag(data: Record<any, any>) {
    return http.post(`${MODEL}/all-tag`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 预测标签 - 当前业务是否开启预测标签 & 是否已打通in-game数据  默认数据
  checkBuiltinTag(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/check-builtin-tag`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 预测标签 - 获取数据
  getBuiltinTag(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/get-builtin-tag`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
